import * as tslib_1 from "tslib";
import { BaseService } from '../base.service';
import { HttpClient } from '@angular/common/http';
var TagService = /** @class */ (function (_super) {
    tslib_1.__extends(TagService, _super);
    function TagService(http) {
        var _this = _super.call(this, 'tag', http) || this;
        _this.http = http;
        return _this;
    }
    return TagService;
}(BaseService));
export { TagService };
